import { apiUrls } from 'consts'
import { axiosGet } from 'shared/api/axios'

const getSavedFilters = async () => {
  const response = await axiosGet(apiUrls.filters + '/' + apiUrls.actionGetFilter)

  return response.data
}

export default getSavedFilters
